import { render, staticRenderFns } from "./cvc-migration-activity.vue?vue&type=template&id=16d527a9"
import script from "./cvc-migration-activity.vue?vue&type=script&lang=js"
export * from "./cvc-migration-activity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports